// Override Settings
var bcSfFilterSettings = {
  general: {
    limit: bcSfFilterConfig.custom.products_per_page,
    loadProductFirst: false,
    activeLoadPreviousPage: true
  },
};

// Declare Templates
var bcSfFilterTemplate = {
  soldOutClass: 'product-item--sold-out',
  saleClass: 'product-item--sale',
  soldOutLabelHtml: '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
  saleLabelHtml: '<div>' + bcSfFilterConfig.label.sale + '</div>',
  vendorHtml: '<div>{{itemVendorLabel}}</div>',

  // Grid Template
  productGridItemHtml:
    '<div class="product-item products-grid__item {{soldOutClass}}">' +
    '{{itemLabel}}' +
    '<a ' +
    'href="{{itemUrl}}" ' +
    'class="product-item__image" ' +
    'style="background-image: url({{itemImageUrl}})" ' +
    'aria-label="{{itemTitle}}"' +
    '></a>' +
    '<h6 class="product-item__title small all-caps">' +
    '<a href="{{itemUrl}}"><strong>{{itemTitle}}</strong></a>' +
    '</h6>' +
    '{{itemDescriptionHtml}}' +
    '<h6 class="product-item__price small all-caps price">{{itemPriceHtml}}</h6>' +
    '</div>',

  // Pagination Template
  previousActiveHtml: '<a class="paging-prev" href="{{itemUrl}}">&larr;</a>',
  previousDisabledHtml: '<span class="paging-prev">&larr;</span>',
  nextActiveHtml: '<a class="paging-next" href="{{itemUrl}}">&rarr;</a>',
  nextDisabledHtml: '<span class="paging-next">&rarr;</span>',
  pageItemHtml: '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
  pageItemSelectedHtml: '<li class="current"><span class="active">{{itemTitle}}</span></li>',
  pageItemRemainHtml: '<li><span>{{itemTitle}}</span></li>',
  paginateHtml: '<div class="paging paging--default">{{previous}}<ul>{{pageItems}}</ul>{{next}}</div>',

  // Sorting Template
  sortingHtml: '<label for="sort-by">' + bcSfFilterConfig.label.sorting + ':' + '</label><select id="sort-by">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  /*** Prepare data ***/
  var images = data.images_info;
  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/

  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;

  // Add label
  var itemLabel = '';
  data.tags.forEach(function(tag) {
    if (tag == bcSfFilterConfig.custom.preorder_tag && bcSfFilterConfig.custom.preorder_image != null) {
      itemLabel =
        '<span ' +
        'class="product-item__label"' +
        'style="background-image: url(\'' +
        bcSfFilterConfig.custom.preorder_image +
        '\');"' +
        'role="img"' +
        '></span>';
    } else {
      if (tag == bcSfFilterConfig.custom.handgrade_tag && bcSfFilterConfig.custom.handgrade_image != null) {
        itemLabel =
          '<span ' +
          'class="product-item__label"' +
          'style="background-image: url(\'' +
          bcSfFilterConfig.custom.handgrade_image +
          '\');"' +
          'role="img"' +
          '></span>';
      }
    }
  });

  itemHtml = itemHtml.replace(/{{itemLabel}}/g, itemLabel);

  // Add Thumbnail
  var itemImageUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
  itemHtml = itemHtml.replace(/{{itemImageUrl}}/g, itemImageUrl);

  // Add soldOut class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

  // Add Price
  var itemPriceHtml = '';

  if (data.title != '') {
    var renderPrice_compare_at_price_min = this.formatMoney(data.compare_at_price_min * 100);
    if(renderPrice_compare_at_price_min.substr(renderPrice_compare_at_price_min.length-3,1)==","){
      renderPrice_compare_at_price_min=renderPrice_compare_at_price_min.replace(',00', '');
    } else {
      renderPrice_compare_at_price_min=renderPrice_compare_at_price_min.replace('.00', '');
    }
    var renderPrice_price_min = this.formatMoney(data.price_min * 100);
    if(renderPrice_price_min.substr(renderPrice_price_min.length-3,1)==","){
      renderPrice_price_min=renderPrice_price_min.replace(',00', '');
    } else {
      renderPrice_price_min=renderPrice_price_min.replace('.00', '');
    }
    if (onSale) {
      itemPriceHtml +=
        '<del class="price__amount">' +
        '<span class="money">' +
        renderPrice_compare_at_price_min +
        '</span>' +
        '</del>' +
        '<ins class="price__amount">' +
        '<span class="money">' +
        renderPrice_price_min +
      '</span>' + '</ins>';
    } else if (priceVaries) {
      itemPriceHtml +=
        bcSfFilterConfig.label.price_from +
        ' ' +
        '<span class="price__amount">' +
        '<span class="money">' +
        renderPrice_price_min +
        '</span>' +
        '</span>';
    } else {
      itemPriceHtml +=
        '<span class="price__amount">' +
        '<span class="money">' +
        renderPrice_price_min +
        '</span>' +
        '</span>';
    }
  }

  itemHtml = itemHtml.replace(/{{itemPriceHtml}}/g, itemPriceHtml);

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data).replace('//', '/'));

  // Add onSale class
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';

  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

  // Add description via tags
  var itemDescriptionHtml = '';
  var targetTagsString = '';
  var itemTitle = data.title;
  var itemShoeColor = '';
  var itemSockColor = '';
  var itemBeltColor = '';
  var itemMaterialDescription = '';
  var itemSoleDescription = '';
  //console.log(data.product_type);
  data.tags.forEach(function(tag) {
    if (tag.indexOf('SHORTNAME|') != -1) {
      itemTitle = tag.split('SHORTNAME|')[1];
    }

    if (tag.indexOf('SHOECOLOUR|') != -1) {
      itemShoeColor = tag.split('|')[1];
    }

    if (tag.indexOf('SOCKCOLOUR|') != -1) {
      itemSockColor = tag.split('|')[1];
    }

    if (tag.indexOf('BELTCOLOUR|') != -1) {
      itemBeltColor = tag.split('|')[1];
    }

    if (tag.indexOf('MATERIALDESCRIPTION|') != -1) {
      itemMaterialDescription = tag.split('|')[1];
    }

    if (tag.indexOf('SOLEDESCRIPTION|') != -1) {
      itemSoleDescription = tag.split('|')[1] + ' ' + Shopify.theme.locale.products.product.sole;
    }
  });

  itemHtml = itemHtml.replace(/{{itemTitle}}/g, itemTitle);

  if (data.product_type == "Accessory") {
    if (data.body_html && data.body_html.indexOf("<!-- split -->") > -1) {
      itemDescriptionHtml = '<div class="product-item__description"><p>'+ data.body_html.split("<!-- split -->")[0]  +'</p></div>';
    } else if(itemSockColor != '') {

    }
  } else if (data.product_type == "Socks") {
    if (itemSockColor != '') {
      itemDescriptionHtml = `<div class="product-item__description"><p>${itemSockColor}</p></div>`;
    }
  } else {
    if (itemShoeColor != '' || itemBeltColor != '' || itemMaterialDescription != '' || itemSoleDescription != '') {
      itemDescriptionHtml += '<div class="product-item__description"><p>';

      if (itemShoeColor != '') {
        itemDescriptionHtml += itemShoeColor + ' ';
      }

      if (itemBeltColor != '') {
        itemDescriptionHtml += itemBeltColor + ' ';
      }

      if (itemMaterialDescription != '') {
        itemDescriptionHtml += itemMaterialDescription + ' ';
      }

      if (itemSoleDescription != '') {
        if (itemShoeColor != '' || itemMaterialDescription != '') {
          itemDescriptionHtml += '<br />' + itemSoleDescription;
        } else {
          itemDescriptionHtml += itemSoleDescription;
        }
      }

      itemDescriptionHtml += '</p></div>';
    }
  }

  itemHtml = itemHtml.replace(/{{itemDescriptionHtml}}/g, itemDescriptionHtml);

  return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
  for (var k in data) {
    //console.log(data[k]);
    // Add Options
    var optionsArr = [];
    for (var i in data[k]['options_with_values']) {
      optionsArr.push(data[k]['options_with_values'][i]['name']);
    }
    data[k]['options'] = optionsArr;

    // Customize variants
    for (var i in data[k]['variants']) {
      var variantOptionArr = [];
      var count = 1;
      var variant = data[k]['variants'][i];
      // Add Options
      var variantOptions = variant['merged_options'];
      if (Array.isArray(variantOptions)) {
        for (var j = 0; j < variantOptions.length; j++) {
          var temp = variantOptions[j].split(':');
          data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
          data[k]['variants'][i]['option_' + temp[0]] = temp[1];
          variantOptionArr.push(temp[1]);
        }
        data[k]['variants'][i]['options'] = variantOptionArr;
      }
      data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
      data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
    }

    // Add Description
    data[k]['description'] = data[k]['body_html'];
  }
  return data;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  if (this.getSettingValue('general.paginationType') == 'default') {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
      jQ(this.selector.bottomPagination).html('');
      return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
      var paginationHtml = bcSfFilterTemplate.paginateHtml;

      // Build Previous
      var previousHtml = currentPage > 1 ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml = currentPage < totalPage ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += pageArr[iPage] == currentPage ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

      jQ(this.selector.bottomPagination).html(paginationHtml);
    }
  }
};

BCSfFilter.prototype.buildDefaultPaginationEvent = function (a) {
  var b = this,
      c = this.getSelector("pagination");
  jQ(c).find("a").unbind("click"),
    jQ(c)
      .find("a")
      .on("click", function (a) {
        a.preventDefault(), (b.internalClick = !0);
        var c = jQ(this).attr("href");
        var k = 64;
        if(window.innerWidth < 768){k=32};
        b.onChangeData(c, "page"), jQ("body,html").animate({ scrollTop: jQ(b.getSelector("products")).offset().top - k - jQ("body").find(".section-collection__nav").height() - jQ("body").find("header.header").height()}, 600);
      });
}

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');

    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ(this.selector.topSorting).html(html);

      // Set current value
      jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
    }
  }
};

// Build Display type (List / Grid / Collage)
// BCSfFilter.prototype.buildFilterDisplayType = function() {
//     var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
//     itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
//     jQ(this.selector.topDisplayType).html(itemHtml);

//     // Active current display type
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
//     if (this.queryParams.display == 'list') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
//     } else if (this.queryParams.display == 'grid') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
//     }
// };

/************************** END BUILD TOOLBAR **************************/

BCSfFilter.prototype.buildPaginationEvent = function(data) {
  switch (this.getSettingValue('general.paginationType')) {
    case 'default':
      this.buildDefaultPaginationEvent(data);
      break;
    case 'load_more':
      this.buildLoadMoreEvent(data);
      this.buildLoadPreviousPageEvent(data);
      break;
    default:
      this.buildInfiniteLoadingEvent(data);
      this.buildLoadPreviousPageEvent(data);
      break;
  }
};

BCSfFilter.prototype.isLoadPreviousPagePaginationType = function() {
  var self = this;
  return (self.isInfiniteLoadingPaginationType() || self.isLoadMorePaginationType()) && self.isAdvancedPaginationType() && self.getSettingValue('general.activeLoadPreviousPage') &&
  jQ(self.getSelector('btnLoadPreviousPageWrapperSelector')).length > 0;
};

// Build Infinite Loading event
BCSfFilter.prototype.buildInfiniteLoadingEvent = function(data) {
  var self = this;
  // Get total products
  var totalProduct = parseInt(data.total_product);
  /* Get limit per page */
  var limitPerPage = parseInt(self.getSettingValue('general.limit'));
  var currentPage = parseInt(self.queryParams.page);
  // Previous page data
  var bcSfFilterCurrentNextPage;
  if (self.isLoadPreviousPagePaginationType()) {
    bcSfFilterCurrentNextPage = parseInt(sessionStorage.getItem(self.getSettingValue('general.sessionStorageCurrentNextPage')));
  } else {
    bcSfFilterCurrentNextPage = currentPage;
  }

  /* Check if total products is greater than limit per page * curent page, do the infinite loading function, else do nothing */
  if (totalProduct > (limitPerPage * bcSfFilterCurrentNextPage)) {
    // Using scrolling to prevent callling onscroll twice
    var scrolling = 0;
    // onscroll event
    // When windown reaches the bottom of product list
    var scrollToBottom = false;
    // Pagination selector
    var paginationSelector = jQ(self.getSelector('bottomPagination'));
    // Check if pagination exists, do the infinite function
    if (paginationSelector.length > 0) {
      // When scroll down, do the infinite function
      jQ(window).scroll(function(e) {
        e.preventDefault();
        e.stopPropagation();
        // Ignore load more if the product list is loading
        if (jQ(self.selector.products).hasClass('bc-sf-product-loading')) return false;

        // get height of scroll bar
        var scrollbarHeight = jQ(window).height() * (jQ(window).height() / jQ(document).outerHeight());
        // get position of the pagination bottom
        var maxPos = parseInt(paginationSelector.offset().top);
        var maxScroll = parseInt(jQ(window).scrollTop()) + scrollbarHeight + self.getSettingValue('general.positionShowInfiniteLoading');
        if ((jQ(window).scrollTop() + jQ(window).height() + scrollbarHeight) >= jQ(document).outerHeight() - 100) {
          scrollToBottom = true;
        }
        // Begin loading more products
        if (scrolling == 0 && data.products.length > 0) {
          if (maxScroll >= maxPos || (maxScroll < maxPos && scrollToBottom)) {
            // Show Loading
            self.showLoadMoreLoading();
            // Prevent scrolling twice
            scrolling = 1;

            // Previous page data
            if (self.isLoadPreviousPagePaginationType()) {
              bcSfFilterCurrentNextPage = parseInt(sessionStorage.getItem(self.getSettingValue('general.sessionStorageCurrentNextPage')));
            } else {
              bcSfFilterCurrentNextPage = currentPage;
            }
            // Next page
            bcSfFilterCurrentNextPage++;

            // Send request if current page is smaller or equal to total number of pages
            var totalPage = Math.ceil(data.total_product / self.getSettingValue('general.limit'));
            // console.log(currentPage, totalPage);
            if (bcSfFilterCurrentNextPage <= totalPage) {
              self.internalClick = true;
              self.queryParams.limit = self.getSettingValue('general.limit');
              self.queryParams.page = bcSfFilterCurrentNextPage;

              // Avoid load twice
              if (!self.getSettingValue('general.showPlaceholderProductList')) {
                jQ(self.selector.products).addClass('bc-sf-product-loading');
              }

              // Append "page" param to url
              // Used to Scroll to the previous position after returning from Product page
              if (self.getSettingValue('general.paginationTypeAdvanced')) {
                var newUrl = self.buildToolbarLink('page', getCurrPage() , bcSfFilterCurrentNextPage);
                // If the previous page feature is activated
                if (self.isLoadPreviousPagePaginationType()) {
                  // Save the previous page data
                  sessionStorage.setItem(self.getSettingValue('general.sessionStorageCurrentNextPage'), bcSfFilterCurrentNextPage);
                  sessionStorage.setItem(self.getSettingValue('general.sessionStoragePreviousPageEvent'), 0);
                }
                self.onChangeData(newUrl, 'page');
              } else {
                self.getFilterData('page');
              }
            }
          }
        }
      });
    }
  }
};

/* Parse URL parameters */
function parse_query_string(query) {
  var vars = query.split("&");
  var query_string = {};
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    var key = decodeURIComponent(pair[0]);
    var value = decodeURIComponent(pair[1]);
    // If first entry with this name
    if (typeof query_string[key] === "undefined") {
      query_string[key] = decodeURIComponent(value);
      // If second entry with this name
    } else if (typeof query_string[key] === "string") {
      var arr = [query_string[key], decodeURIComponent(value)];
      query_string[key] = arr;
      // If third or later entry with this name
    } else {
      query_string[key].push(decodeURIComponent(value));
    }
  }
  return query_string;
}

/* Get the current page from address */
function getCurrPage() {
  var url = parse_query_string(window.location.search.substring(1));
  return url.page;
}

BCSfFilter.prototype.buildAll = function(data, isBuildFilterTree, eventType) {
  var self = this;
    // Prepare data
    var paginationSelector = this.selector.pagination;
    var totalProduct = data.total_product;
    if (isBuildFilterTree === true && data.hasOwnProperty('filter')) {
        // Build Filter Tree
        this.buildFilterTree(data.filter.options);
        // Build Filter Selections
        if (this.getSettingValue('general.showRefineBy')) {
            this.buildFilterSelection(data);
        }
        // Customize Filter tree on mobile
        this.buildFilterTreeMobile();
        // Build Filter Tree Button for Mobile
        this.buildFilterTreeMobileButton(data);
        // Build events: clear filter option, clear all filter options and toggle on title
        this.buildAdditionalFilterEvent();
    }
    if (totalProduct > 0) {
        // Build Product List
        this.buildProductList(data.products, eventType);
        // Build Pagination
        var paginationType = this.getSettingValue('general.paginationType');
        if (paginationType == 'default') {
            this.buildPagination(totalProduct);
        } else {
            jQ(paginationSelector).empty();
            if (self.isLoadMorePaginationType()) {
              // Build load more button
              this.buildLoadMoreButton(totalProduct);
              // Build previous button
              this.buildLoadPreviousButton(totalProduct, eventType);
            } else if (self.isInfiniteLoadingPaginationType()) {
              // Build previous button
              this.buildLoadPreviousButton(totalProduct, eventType);
            }
        }
        // Build Toolbar
        this.buildToolbar();
        // Build Toolbar Event (Pagination, Sorting,...)
        this.buildToolbarEvent(data);
        // Hide Error Notification after build succesfully
        jQ(this.selector.filterWrapper).show();
        var topNotificationSelector = this.selector.topNotification;
        if (jQ(topNotificationSelector).length > 0) jQ(topNotificationSelector).empty();
    }
    // Show Products & Pagination after building (also used for Fallback)
    jQ(this.selector.products).removeAttr('data-bc-sort');
    jQ(paginationSelector).show();
    // Build Additional Elements
    this.buildAdditionalElements(data, eventType);
    // Build Scroll to Top
    this.buildScrollToTop();
    // Scroll to previous position when going back from product page
    this.scrollBackPositionHistoryBack();
    // Build Page information
    if (eventType == 'collection') this.buildPageInfo(data);
    // Build Search
    if (this.isSearchPage()) {
        this.buildSEOTitle(data);
        this.buildSearchResultHeader(data);
        this.buildSearchResultNumber(data);
    }
    // Add Meta tag to exclude pages with filter params from Goolge crawl
    this.buildRobotsMetaTag(data);
    this.selectFilter = false;
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
  var self = this;
  if (!self.getSettingValue('general.showPlaceholderProductList')) {
    jQ(self.selector.products).removeClass('bc-sf-product-loading');
  }
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  // Products count
  var totalProductsCountText = '';

  if (data.total_product) {
    totalProductsCountText =
      data.total_product +
      ' ' +
      (data.total_product > 1 ? bcSfFilterConfig.label.items_with_count_other : bcSfFilterConfig.label.items_with_count_one);
  } else {
    totalProductsCountText = bcSfFilterConfig.label.no_products;
  }
  jQ('.js-products-count').text(totalProductsCountText);
  jQ('.js-current-products-count').text(data.total_product);
};


/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
